"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.secondaryForeground = exports.secondary = exports.primaryForeground = exports.primary = exports.positiveForeground = exports.positive = exports.negativeForeground = exports.negative = exports.foregroundMuted = exports.foreground = void 0;
require("./foregroundColor.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const foreground = "cds-foreground-f1yzxzgu";
exports.foreground = foreground;
const foregroundMuted = "cds-foregroundMuted-f1vw1sy6";
exports.foregroundMuted = foregroundMuted;
const primary = "cds-primary-piuvss6";
exports.primary = primary;
const primaryForeground = "cds-primaryForeground-pxcz3o7";
exports.primaryForeground = primaryForeground;
const secondary = "cds-secondary-s1cmchb1";
exports.secondary = secondary;
const secondaryForeground = "cds-secondaryForeground-s111xox1";
exports.secondaryForeground = secondaryForeground;
const positive = "cds-positive-p1xe9yrm";
exports.positive = positive;
const positiveForeground = "cds-positiveForeground-p1oldv47";
exports.positiveForeground = positiveForeground;
const negative = "cds-negative-n10xoad3";
exports.negative = negative;
const negativeForeground = "cds-negativeForeground-njzyi9j";
exports.negativeForeground = negativeForeground;
const warning = "cds-warning-w1f3i34f";
exports.warning = warning;